import React, { FocusEvent } from 'react';
import InputMask from 'react-input-mask';

import { Field as FormikField } from 'formik';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, StyledInput } from './styles';

interface Props {
  label?: string;
  name?: string;
  type?: string;
  placeholder?: string;
  isMultiline?: boolean;
  startAdornment?: React.ReactNode;
  mask?: string | Array<string | RegExp>;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
}

const Field = ({ label, name, type, placeholder, mask, startAdornment, isMultiline, onFocus }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Container>
      <FormikField name={name}>
        {({ field, form }) => {
          const error = form && form.errors[field.name] ? t(String(form.errors[field.name])) : undefined;
          const hasTouched = form ? Boolean(form.touched[field.name]) : false;
          return (
            <InputMask {...field} mask={mask || ''} maskChar="" onFocus={onFocus}>
              {() => (
                <StyledInput
                  {...field}
                  InputProps={{
                    startAdornment,
                  }}
                  label={label}
                  placeholder={placeholder}
                  error={!!error && hasTouched}
                  helperText={!!error && hasTouched ? error : ''}
                  multiline={isMultiline}
                  onFocus={onFocus}
                  type={type}
                />
              )}
            </InputMask>
          );
        }}
      </FormikField>
    </Container>
  );
};

export default Field;
